var gema = {
  theme: function(json,data,$){
    var tb = '',static = '',first_image = '',button_quick_view='',popup = '',classquickview = '',compare_price_hidden='',style_quick_view='',style_variants='',hover = '',badges = '',image = data.asset_url+'no-image.svg',images_thumb='',content_images_thumb='',cl_thumb='',image_content = '',compare_at_price = '',buttons = '',paginateTop='',paginateBottom='',free_shipping,afterpay,zip,klarna,prodId,boldOptionExists,leftStock='',optQty,paymentButtons='',reviews='';
    if(json.collection)
    {
      $('.tb-title-collection').html(json.collection.title);
      $('.tb-bodyhtml-collection').html(json.collection.body_html);
    }
	if(json.products.length > 0)
    { 
	  //console.log(json);
      //console.log(videlxu);
      //console.log(theme);
      //console.log('metafields: ' + shop.metafields );
      //console.log('BOLD ' + window.BOLD.common.Shopify.metafields );
      //console.log('Value: ' + window.BOLD.options.path);
      //var json_variant = JSON.stringify(value.variants);
      $.each(json.products, function( index, value ) {
          boldOptionExists='false';
          //boldOptionDropdown='';
          //boldOptionText='';
          paymentButtons = '';
          reviews = '';
          leftStock='';
          images_thumb = '';
          content_images_thumb = '';
          cl_thumb = '';
          style_quick_view = '1';
          style_variants = '';
		  first_image = '';
            if(value.images)
            {
              $.each(value.images, function( x, u ) {
                cl_thumb = '';
                first_image = '';
                if(x == 0)
                {
                  first_image = ' tb-first-image-thumb';
                  cl_thumb = ' active';
                }
                images_thumb = images_thumb.concat('<li><img src="'+gema.resizeImage(u.src,'x700')+'" style="display:none"><a class="tb-thumb-onclick'+cl_thumb+first_image+' tb-thumb-id-'+value.id+' tb-thumb-id-'+value.id+'-'+u.id+'" href="'+gema.resizeImage(u.src,'x700')+'" data-id="'+value.id+'" data-thumb="'+u.id+'"><img src="'+gema.resizeImage(u.src,'small')+'" /></a></li>');
              });
              content_images_thumb = '<ul class="tb-thumb-swatch tb-slick-carousel-thumb tb-thumb-function-'+value.id+'" style="display:none">'+images_thumb+'</ul>';
            }
            compare_at_price = '';
          	buttons = '<div class="tb-content-button-add-to-cart"><a class="tb-button-add-to-cart btn" data-id="'+value.id+'" href="javascript:void(0);">Add to cart</a><a href="/products/'+value.handle+'" class="tb-button-details btn btn--secondary tb-product-link-'+value.id+'" href="javascript:void(0);" style="display:none;" >Details</a><button style="display:none;" type="submit" name="add" id="AddToCart-'+value.id+'" class="btn btn--full add-to-cart btn--secondary bold_clone" data-event-queue-button="0"><span id="AddToCartText-'+value.id+'">Add to cart</span></button></div>';
            image = data.asset_url+'tb-noimage.jpg'
            image_content = '<a href="/products/'+value.handle+'" class="tb-productitem--image-link tb-product-link-'+value.id+'">\
    						<figure class="tb-productitem--image" data-product-item-image="">\
       						<img alt="'+value.title+'" class="tb-image-fisrt-'+value.id+'" src="'+image+'">\
    						</figure>\
							</a>';
			if(value.featured_image != null)
			{
			  image = gema.resizeImage(value.featured_image.src,'x700');
              image_content = '<a href="/products/'+value.handle+'" class="tb-productitem--image-link tb-product-link-'+value.id+'">\
    						<figure class="tb-productitem--image" data-product-item-image="">\
    						<img alt="'+value.title+'" class="tb-image-fisrt-'+value.id+'" src="'+image+'">\
    						</figure>\
    						</a>';
            }

			if(data.compare_price > 0)
            {
              if(value.price < value.compare_at_price)
              {
                if(value.compare_at_price)
                {
                  compare_at_price = snappy.Currency.formatMoney(value.compare_at_price, data['money_format']);
                }
              }
            }else{
              compare_price_hidden = ' style="display:none;"';
            }
          
            badges = value.badges;
        	//console.log(badges);
            
            if( value.price >= 150.00 ) {
				//console.log('Price: ' + value.price);
              free_shipping = '<div class="tb-tag-product-label tb-top-left free" style="background: rgb(213, 223, 38); color: rgb(34, 34, 34);position:relative; top:-5px;"><span class="tb-tag-right-arrow" style="border-left-color: #ffeb3b;"></span> <div class="tb-tag-products-badges-content tb-shipping-products-badges-'+value.id+'"><span>Free Shipping</span></div></div>';
            } else {
              free_shipping = '';
            }
        	
        	if( value.count_stock > '0' && value.count_stock < 6 ) {
        		leftStock = '<div id="ProductInventory-'+value.id+'" class="product__inventory " style="margin-top: 30px !important;" ><strong>  Only '+value.count_stock+' items in stock!</strong></div>';
        	}
          
          	if(data.quickv == 0)
            {
              style_variants = ' style="display:none;"';
            }
            if(data.swatchv == 0)
            {
              buttons = '<div class="tb-content-button-add-to-cart"><a href="/products/'+value.handle+'" class="tb-button-details tb-w-100 btn btn--secondary tb-product-link-'+value.id+'" href="javascript:void(0);">Details</a></div>';
            }
          
            if(data.quick_view_status == 0)
            {
              style_quick_view = ' style="display:none;"';
            }
        
        	paymentButtons = '<div data-shopify="payment-button" class="shopify-payment-button"><button class="shopify-payment-button__button shopify-payment-button__button--unbranded shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true"> </button><button class="shopify-payment-button__more-options shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true"> </button></div>';
        
        	optQty = '<div class="product__quantity product__quantity--button">\
            <label for="Quantity-'+value.id+'">Quantity</label>\
            <div class="js-qty__wrapper">\
            <input type="text" id="Quantity-'+value.id+'" class="js-qty__num" value="1" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">\
            <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">\
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>\
            <span class="icon__fallback-text" aria-hidden="true">−</span>\
            </button>\
            <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">\
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>\
            <span class="icon__fallback-text" aria-hidden="true">+</span>\
            </button>\
            </div></div>';
        
        	//console.log(value.id);
        	prodId = value.id;
            
            var boldOptionDropdown=''
            var boldOptionText='';
        	$.getJSON('https://option.boldapps.net/v2/tennisgear.myshopify.com/generate_option/'+prodId+'?v=1.0', function(data) {
                //console.log(data.option_product.option_sets[0].options[0].options_values);
              //console.log(data);
              var items = '';
              if(data.option_product != null && data.option_product.option_sets[0].options[0].type == 'dropdown' ) {
                //boldOptionExists = 'true';
                $.each( data.option_product.option_sets[0].options[0].options_values, function( key, val ) {
                  items += '<option value="' + val.value + '" data-option.handle="'+val.handle+ '" data-option-product="'+val.product_id+'" data-option-variant="'+val.variant+'" data-option-variant_title="'+val.variant_title+'" data-option-price="' + val.price + '" data-option_value_key="' + key + '">"' + val.value + '"</option>';
                }); 
                boldOptionDropdown = '<label><span class="bold_option_title">'+data.option_product.option_sets[0].options[0].public_name+'<span class="bold_tooltip"><small>'+data.option_product.option_sets[0].options[0].additional_info+'</small></span></span><span class="bold_option_element"><select name="properties[Select your string]" class="dd_'+data.option_product.option_sets[0].id+'_'+data.option_product.option_sets[0].options[0].id+'"><option value="">-- Choose Select your string --</option>'+items+'</select></span></label>';
                //console.log('INNNNN');
              } else {
                boldOptionDropdown = '';              
              }
              if(data.option_product != null && data.option_product.option_sets[0].options[1].type == 'textbox' ) {
                boldOptionText = '<label><span class="bold_option_title">'+data.option_product.option_sets[0].options[1].public_name+'<span class="bold_tooltip"><small>'+data.option_product.option_sets[0].options[0].additional_info+'</small></span></span><span class="bold_option_element"><input name="properties['+data.option_product.option_sets[0].options[1].public_name+']" class="tb_'+data.option_product.option_sets[0].id+'_'+data.option_product.option_sets[0].options[1].id+'" type="text"></span></label>';
              } else {
                boldOptionText = '';
              }
              
              paymentButtons = '';
              //console.log(boldOptionDropdown);
              //console.log(boldOptionDropdown); 
              $('.tb-content-details.product-'+value.id+' .bold_option_dropdown').html(boldOptionDropdown);
              $('.tb-content-details.product-'+value.id+' .bold_option_textbox').html(boldOptionText);
              $('.tb-content-details.product-'+value.id+' .bold_option_dropdown select').change(function () {
                   
                	var optPrice = '';
                	var theName = $(this).val();
                	var theProdId = $('option:selected', this).attr('data-option-product');
                	var theVaritId = $('option:selected', this).attr('data-option-variant');
                	var thePrice = $('option:selected', this).attr('data-option-price');
                    var boldOptionTotal = '<input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="'+theName+'">\
                                           <input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="'+theVaritId+'">\
                                           <input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="'+theProdId+'">\
                                           <input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="'+thePrice+'">\
                                           <input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="">\
                                           <input type="hidden" name="properties[_boldLineItemOneTime]" data-property-name="_boldLineItemOneTime" value="">\
                                           <input type="hidden" name="properties[_boldProductOneTime]" data-property-name="_boldProductOneTime" value="">\
                                           <input type="hidden" name="properties[_boldOrderOneTime]" data-property-name="_boldOrderOneTime" value="">\
                                           <input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="">';
                      var selectedVal = $('option:selected', this).attr('data-option-price');
                      if( selectedVal > '0' ) {
                        optPrice = snappy.Currency.formatMoney(selectedVal, data['money_format']);
                        $('.tb-content-details.product-'+value.id+' .bold_option_total').html('<div style="font-size: 15px !important;" >Total Extras:  <span>'+optPrice+'</span></div>'+ boldOptionTotal);
                      } else {
                        $('.tb-content-details.product-'+value.id+' .bold_option_total').html('');
                      }
                	  $('.bold_option_dropdown').removeClass('bold_option_error');
                      console.log( selectedVal + ' - ' + optPrice );
                        //var firstDropVal = $('#pick').val();
                });
            });
        
        	//console.log(boldOptionDropdown);
        	reviews = '<div class="yotpo bottomLine yotpo-medium" data-product-id="'+value.id+'" data-yotpo-element-id=""> <div class="yotpo-display-wrapper" style="visibility: hidden;"><div class="standalone-bottomline" data-source="default" tabindex="-1"><div class="yotpo-bottomline pull-left  star-clickable" tabindex="0"><span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="sr-only">5.0 star rating</span></span><a href="/products/'+value.handle+'?variant='+value.variant_id.id+'" class="text-m" aria-label="1 reviews" tabindex="-1">Write a Review</a><div class="yotpo-clr"></div></div><div class="yotpo-clr"></div> </div><div class="yotpo-clr"></div></div></div>';
        	afterpay = '<p class="afterpay-paragraph" data-product-id="'+value.id+'" style="margin-top: 0px; margin-bottom: 0px;"><span class="afterpay-text1">or make 4 interest-free payments of </span><strong class="afterpay-instalments">$84.75&nbsp;AUD</strong><span class="afterpay-text2"> fortnightly with </span><img class="afterpay-logo" src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@3x.png 3x" width="100" height="21" alt="Afterpay" style="vertical-align: middle; width: 100px; border: 0px;"><span class="afterpay-text3">&nbsp;</span><a class="afterpay-link" href="https://www.afterpay.com/terms" target="_blank"><u class="afterpay-link-inner" style="font-size: 12px; text-decoration: underline;">More info</u></a></p>';
        	zip = '<span style="cursor:pointer" id="shopify-zip-prod-widget" data-zm-asset="productwidget" data-zm-widget="popup" data-zm-popup-asset="termsdialog" class="zip-widget__wrapper zip-widget__wrapper--display-popup zip-widget__wrapper--type-productwidget" data-zm-rendered="true"><meta charset="utf-8"> <style> @font-face { font-family: "Cooper Lt BT"; src: url(https://static.zipmoney.com.au/fonts/CooperLight.woff2); } @font-face { font-family: "Sharp Grotesk Medium"; src: url(https://static.zipmoney.com.au/fonts/SharpGroteskMedium20.woff); } @font-face { font-family: "Sharp Grotesk Book"; src: url(https://static.zipmoney.com.au/fonts/SharpGroteskBook20.woff2); } .zip-container { margin: 0 auto; align-items: center; } .zip-container .zip-logo { height: 35px; vertical-align: middle; display: inline-block; margin: -2px 0 5px 0px; } .zip-container span { font-size: 11px; margin-top: 2px; margin-bottom: 0px; display: inline; } .zip-payment-amount { font-weight: 700; } #zip-info-link { line-height: normal; display: inline-block; padding: 0; margin: 0; border: none; color: inherit; text-decoration: none; background: transparent; font-family: sans-serif; cursor: pointer; text-align: center; transition: background 250ms ease-in-out, transform 150ms ease; -webkit-appearance: none; -moz-appearance: none; } .zip-learn-more { padding-left: 1px; font-size: smaller !important; } </style> <p class="zip-container"> <span>or Zip it from </span><span class="zip-payment-amount">$10/week</span> <span>with</span> <img class="zip-logo" src="https://static.zipmoney.com.au/assets/default/product-widget/img/zip-button-wht.svg"> <button id="zip-info-link" class="zip-info-link" tabindex="0" aria-label="Zip payment information - Opens a dialog" title="Zip payment Information"> <span class="zip-learn-more">ⓘ</span> </button> </p>';
        	klarna = '<div class="klarna-badge" style="width: 100%;height: 40px;"> <div class="badge"><svg role="img" focusable="false" width="60px" height="30px" viewBox="0 0 60 30" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Klarna badge</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M55.5,30 L4.5,30 C2.025,30 0,27.975 0,25.5 L0,4.5 C0,2.0265 2.025,0 4.5,0 L55.5,0 C57.9735,0 60,2.0265 60,4.5 L60,25.5 C60,27.975 57.9735,30 55.5,30" fill="#FFB3C7"></path><path d="M45.74265,18.1758 C44.72265,18.1758 43.89615,17.3928 43.89615,16.4238 C43.89615,15.4578 44.72265,14.6733 45.74265,14.6733 C46.76265,14.6733 47.58915,15.4578 47.58915,16.4238 C47.58915,17.3928 46.76265,18.1758 45.74265,18.1758 L45.74265,18.1758 Z M47.59515,13.0188 L47.59515,13.4568 C47.02065,13.0638 46.32615,12.8313 45.57615,12.8313 C43.59165,12.8313 41.98365,14.4408 41.98365,16.4238 C41.98365,18.4083 43.59165,20.0163 45.57615,20.0163 C46.32615,20.0163 47.02065,19.7853 47.59515,19.3938 L47.59515,19.8288 L49.63515,19.8288 L49.63515,13.0188 L47.59515,13.0188 Z" fill="#000000"></path><path d="M16.04295,9.9843 L13.83045,9.9843 C13.83045,11.7963 12.99945,13.4583 11.54595,14.5473 L10.66995,15.2028 L14.06445,19.8303 L16.85445,19.8303 L13.73145,15.5733 C15.21045,14.0988 16.04295,12.1158 16.04295,9.9843" fill="#000000"></path><polygon fill="#000000" points="8.13525 19.83045 10.40025 19.83045 10.40025 9.98445 8.13525 9.98445"></polygon><polygon fill="#000000" points="17.51175 19.82745 19.64625 19.82745 19.64625 9.98445 17.51175 9.98445"></polygon><path d="M38.3613,12.8364 C37.5483,12.8364 36.7773,13.0899 36.2628,13.7874 L36.2628,13.0209 L34.2333,13.0209 L34.2333,19.8279 L36.2868,19.8279 L36.2868,16.2504 C36.2868,15.2154 36.9813,14.7084 37.8183,14.7084 C38.7123,14.7084 39.2283,15.2424 39.2283,16.2369 L39.2283,19.8279 L41.2638,19.8279 L41.2638,15.4974 C41.2638,13.9149 40.0038,12.8364 38.3613,12.8364" fill="#000000"></path><path d="M24.24015,18.1758 C23.22015,18.1758 22.39365,17.3928 22.39365,16.4238 C22.39365,15.4578 23.22015,14.6733 24.24015,14.6733 C25.26015,14.6733 26.08665,15.4578 26.08665,16.4238 C26.08665,17.3928 25.26015,18.1758 24.24015,18.1758 L24.24015,18.1758 Z M26.09265,13.0188 L26.09265,13.4568 C25.51815,13.0638 24.82365,12.8313 24.07365,12.8313 C22.08915,12.8313 20.48115,14.4408 20.48115,16.4238 C20.48115,18.4083 22.08915,20.0163 24.07365,20.0163 C24.82365,20.0163 25.51815,19.7853 26.09265,19.3938 L26.09265,19.8288 L28.13265,19.8288 L28.13265,13.0188 L26.09265,13.0188 Z" fill="#000000"></path><path d="M31.2846,13.90725 L31.2846,13.02075 L29.1981,13.02075 L29.1981,19.82775 L31.2891,19.82775 L31.2891,16.64925 C31.2891,15.57675 32.4516,15.00075 33.2571,15.00075 C33.2661,15.00075 33.2736,15.00075 33.2826,15.00075 L33.2826,13.02075 C32.4546,13.02075 31.6926,13.37625 31.2846,13.90725" fill="#000000"></path><path d="M51.7983,17.4126 C51.0918,17.4126 50.5188,17.9856 50.5188,18.6936 C50.5188,19.3986 51.0918,19.9716 51.7983,19.9716 C52.5048,19.9716 53.0778,19.3986 53.0778,18.6936 C53.0778,17.9856 52.5048,17.4126 51.7983,17.4126" fill="#000000"></path></g></svg>4 interest-free payments of $84.75. Learn more</div> </klarna-placement></div>';
        
            hover = '<div class="tb-product-inner-snappy-filter tb-content-hover" data-id="'+value.id+'"'+style_quick_view+'>\
			  <div class="tb-content-image-turbofilter">\
				<div class="tb-content-hover-badges">'+badges+'</div>'+image_content+'\
			  </div>\
			  '+content_images_thumb+'\
			  <div class="tb-product-card-details">\
				<div class="tb-grid-view-item__title">'+value.title+'</div>\
				  <div class="tb-grid-view-item__meta">\
					<s class="tb-product-compare-price tb-compare-at-price-'+value.id+'"'+compare_price_hidden+'>'+compare_at_price+'</s>\
					<span class="tb-product-price__price tb-price-'+value.id+' product-price__sale">\
						<span class="tb-product__price">'+snappy.Currency.formatMoney(value.price, data['money_format'])+'</span>\
				    </span>\
				  </div>\
<div class="tb-left-quantity" style="display:none"></div>\
			  </div>\
			  <div class="tb-content-swatches-cn tb-swatch-products-'+value.id+'"'+style_variants+'></div>\
			  '+buttons+'\
			</div>';
          
            if(data.design_quickview == 1)
            {
              //button_quick_view = '<div class="quick-view-button"><a class="quick-view" data-handle="'+value.handle+'">Quick View</a></div>';
              //button_quick_view = '<div class="quick-product__btn js-modal-open-quick-modal-'+value.id+' small--hide" data-product-id="'+value.id+'" aria-expanded="false"><span class="quick-product__label">Quick view</span></div>';
              //button_quick_view = '<div class="quick-view-button"><a class="quick-product__btn" data-product-id="'+value.id+'" href="javascript:void(0);">Quick View</a></div>';
              button_quick_view = '<div class="tb-quickview-button"><a href="tb-content-quick-view-'+value.id+'" class="tb-open-quick-view" data-href="/products/'+value.handle+'" data-id="'+value.id+'">Quick View</a></div>';
              hover = '';
              classquickview = ' tb-quick-view';
              popup = '<div class="tb-popup-quick-view-'+value.id+' tb-content-mega-quick-view mfp-hide white-popup-block" id="tb-content-quick-view-'+value.id+'" data-id="'+value.id+'"><div class="tb-content-image-src"><div class="tb-content-image-turbofilter">\
				<div class="tb-content-hover-badges">'+badges+'</div>'+image_content+'\
			  </div>\
			  '+content_images_thumb+'<div class="tb-description-onload"></div></div>\
			  <div class="tb-content-details product-'+value.id+' product-single__form">\
			  <div class="tb-product-card-details">\
				<div class="tb-grid-view-item__title"><h2 class="h2 product-single__title">'+value.title+'</h2></div>\
				  <div class="tb-grid-view-item__meta">\
					<span id="ProductPrice-'+value.id+'" class="product__price">\
					<s class="tb-product-compare-price tb-compare-at-price-'+value.id+'"'+compare_price_hidden+'>'+compare_at_price+'</s>\
					<span class="tb-product-price__price tb-price-'+value.id+' product-price__sale">\
					<span class="tb-product__price">'+snappy.Currency.formatMoney(value.price, data['money_format'])+'</span>\
				    </span>\
                    <small style="display:inline-block; ">inc. GST</small>\
                   </span>\
					<span style="display:inline-block;">'+free_shipping+'</span>\
					<div>'+afterpay+'</div>\
					<div>'+klarna+'</div>\
					<div>'+zip+'</div>\
					<div>'+reviews+'</div>\
				  </div>\
				  <div class="tb-left-quantity"></div>\
			  </div>\
<hr class="" />\
			  <form method="post" action="/cart/add" id="AddToCartForm-'+value.id+'" accept-charset="UTF-8" class="product-single__form" enctype="multipart/form-data">\
			  <input type="hidden" name="form_type" value="product">\
			  <input type="hidden" name="utf8" value="✓">\
			  <div class="bold_options" data-product-id="'+value.id+'">\
              <div class="bold_options bold_options_loaded"><div class="bold_option_product_title"></div><div class="bold_option_set">\
			  <div class="bold_option bold_option_dropdown ">'+boldOptionDropdown+'</div>\
			  <div class="bold_option bold_option_textbox ">'+boldOptionText+'</div></div>\
			  <div class="bold_option_total"></div></div>\
              </div>\
			  <div class="tb-content-swatches-cn tb-swatch-products-'+value.id+'"'+style_variants+'></div>\
'+optQty + ' ' + leftStock + ' ' +buttons+' '+paymentButtons+'</form></div></div>';
            }

            static = '<div class="tb-product-inner-snappy-filter tb-content-static'+classquickview+'" data-id="'+value.id+'"><div class="tb-content-static-badges">'+badges+ ' '+free_shipping+'</div>\
			  <div class="tb-content-image-turbofilter">\
				'+image_content+button_quick_view+'\
			  </div>\
			  <div class="tb-product-card-details">\
				<div class="tb-grid-view-item__title">'+value.title+'</div>\
				  <div class="tb-grid-view-item__meta">\
					<s class="tb-product-compare-price tb-compare-at-price-'+value.id+'"'+compare_price_hidden+'>'+compare_at_price+'</s>\
					<span class="tb-product-price__price tb-price-'+value.id+' product-price__sale">\
					<span class="tb-product__price">'+snappy.Currency.formatMoney(value.price, data['money_format'])+'</span>\
				  </span>\
				  <div class="tb-left-quantity"></div>\
				</div>\
			  </div>\
			</div>';
			tb = tb.concat('<li class="tb-product product-'+value.id+'" data-id="'+value.id+'" data-quantity="'+value.count_stock+'">\
			<div class="tb-apolomultimedia-data-product" data-id="'+value.id+'" data-handle="'+value.handle+'"></div>\
			'+static+hover+popup+'\
			</li>');
		});
 	  paginateTop = '<div class="tb-content-paginate tb-top" data-pisition="top">'+json.paginate+'</div>';
      paginateBottom = '<div class="tb-content-paginate tb-bottom" data-pisition="bottom">'+json.paginate+'</div>';
      gema.loadContent(paginateTop+'<ul class="tb-products-content">'+tb+'</ul>'+paginateBottom);
      gema.addStyle(json,data,$);
      
      gema.addActions();
      
      //theme.QtySelector();
      //quickView();
      //theme.initQuickShop();
      //theme.init();
      //Modal.prototype.init();
      //theme.Modals();
      //theme.init();
      //theme.initSecondary();
      //theme.reinitProductGridItem();
      var id = $(".quick-product__btn").data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
      //theme.init();
      //console.log('Theme: ' + theme);
      //new theme.Modals();
      //Modals(modalId, name);
      //console.log('Theme: ' + theme);
      //$(".quick-product__btn").click(function (e) {
        //var id = $(this).data('product-id');
        //var modalId = 'QuickShopModal-' + id;
        //var name = 'quick-modal-' + id;

      
      var qtyInput = $('.js-qty__num');
      var qtyPlus = $('.js-qty__adjust--plus');
      var qtyMinus = $('.js-qty__adjust--minus');
      var qtyminValue = $('.js-qty__num').attr('min') || 1;
      
      qtyPlus.on('click', function() {
        var qty = this.validateQty(qtyInput.val());
        this.addQty(qty);
      }.bind(this));

      qtyMinus.on('click', function() {
        var qty = this.validateQty(qtyInput.val());
        this.subtractQty(qty);
      }.bind(this));

      qtyInput.on('change', function() {
        var qty = this.validateQty($('.js-qty__num').val());
        this.changeQty(qty);
      }.bind(this));
      
      //theme.AjaxProduct();
      
      if ($('.product-single__form').length) {
        //$('.product-single__form').on('submit', theme.addItemFromForm.bind(this));
      }
      
	  var boldOptChk = $('.bold_options').find('.bold_option.bold_option_dropdown select').length;
  	  console.log('Bold Options: ' + boldOptChk );
      if(boldOptChk) { 
        $('.shopify-payment-button').css('display','none');
      }

      

        console.log('Clicked');

      //});
      
	}else{
        gema.loadContent('<div class="tb-no-products-found">No products found</div>');
    }
  },
  addStyle:function(json,data,$){
    if(data.filter_status == 0)
    {
      $('#snappy_filter__filters').css('width','100%');
      $('#snappy_filter__filters').css('margin-bottom','20px');
      return false;
    }
    $('#load-ajax-products').css('width','80%');
    $('#load-ajax-products').css('display','inline-block');
    $('#load-ajax-products').css('float','left');
  },
  loadContent:function(result){
    $('#load-ajax-products').html(result);
  },
  addActions:function(){
    //console.log("INNNN" + $(".tb-content-details .bold_option_element select").length);
    
  },
  resizeImage:function(t, r) {
    var em = '';
    try {
        if ("original" == r) return t;
        var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        if(e.input.indexOf('?v=') > -1)
        {
          em = e.input.split('?v=');
          em = em[1];
        }
        return e[1] + "_" + r + "." + e[2]+'?v='+em
    } catch (r) {
        return t
    }
  },
  addQty: function(number) {
    var qty = number + 1;
    this.changeQty(qty);
  },

  subtractQty: function(number) {
    var qty = number - 1;
    var qtyminValue = $('.js-qty__num').attr('min') || 1;
    //console.log( 'Min: ' + qtyminValue );
    if (qty <= qtyminValue) {
      qty = qtyminValue;
    }
    this.changeQty(qty);
  },

  changeQty: function(qty) {    
    var qtyminValue = $('.js-qty__num').attr('min') || 1;
    if (qty <= qtyminValue) {
      $('.js-qty__num').val(qtyminValue);
    } else {
      $('.js-qty__num').val(qty);
    }
    //$('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
  },

  validateQty: function(number) {
    if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      number = 1;
    }
    return parseInt(number);
  },
}